@if (displayedEducationSection == "videos") {
  <div class="row">
    <div class="col">
      <div class="m-x-20">
        <div class="d-flex m-b-30 justify-content-between align-items-center">
          <fui-heading [text]="'Manage Videos'" [level]="5"></fui-heading>
          <div>
            <span class="btn btn-secondary btn-sm" tabindex="0" (click)="sync()">{{ syncing ? "Syncing..." : "Sync PreSonus Videos" }}</span>
            &nbsp;
            <span class="btn btn-secondary btn-sm" tabindex="0" (click)="addVideo()">Add Video or Playlist</span>
          </div>
        </div>
        <div class="d-flex flex-wrap m-b-20 learn-content-filters" [ngStyle]="{ opacity: filters.query ? '.5' : '1' }">
          <div class="form-group m-r-10">
            <small class="text-muted">Platform</small>
            <select [disabled]="filters.query ? true : false" [class.disabled]="filters.query" class="form-control custom-select-sm" (change)="filter()" [(ngModel)]="filters.platform">
              <option value="any">Any</option>
              <option value="youtube">YouTube</option>
              <option value="vimeo">Vimeo</option>
            </select>
          </div>
          <div class="form-group m-r-10">
            <small class="text-muted">Brand</small>
            <select [disabled]="filters.query ? true : false" [class.disabled]="filters.query" class="form-control custom-select-sm" (change)="filter()" [(ngModel)]="filters.brand">
              <option value="any">Any</option>
              <option value="fender">Fender</option>
              <option value="presonus">Presonus</option>
            </select>
          </div>
          <div class="form-group m-r-10">
            <small class="text-muted">Status</small>
            <select [disabled]="filters.query ? true : false" [class.disabled]="filters.query" class="form-control custom-select-sm" (change)="filter()" [(ngModel)]="filters.status">
              <option value="any">Pending or Approved</option>
              <option value="approved">Approved</option>
              <option value="pending">Pending</option>
              <option value="ignored">Ignored</option>
            </select>
          </div>
          <div class="form-group m-r-10">
            <small class="text-muted">By Product Associated</small>
            <select [disabled]="filters.query ? true : false" [class.disabled]="filters.query" class="form-control custom-select-sm" (change)="filter()" [(ngModel)]="filters.product">
              <option value="any">Any</option>
              @for (prod of contentService.productsAssociatedWithVideos; track prod) {
                <option [value]="prod.id">{{ prod.title }}</option>
              }
            </select>
          </div>
          <div class="form-group m-r-10">
            <small class="text-muted">By Tag</small>
            <select [disabled]="filters.query ? true : false" [class.disabled]="filters.query" class="form-control custom-select-sm" (change)="filter()" [(ngModel)]="filters.tag">
              <option value="any">Any</option>
              @for (tag of contentService.tagsAssociatedWithVideos; track tag) {
                <option [value]="tag.id">{{ tag.title }}</option>
              }
            </select>
          </div>
          <div class="form-group m-r-10">
            <small class="text-muted">Duration</small>
            <select [disabled]="filters.query ? true : false" [class.disabled]="filters.query" class="form-control custom-select-sm" (change)="filter()" [(ngModel)]="filters.duration">
              <option value="any">Any</option>
              <option value="0_60">Under a minute</option>
              <option value="60_300">1 to 5 minutes</option>
              <option value="300_600">5 to 10 minutes</option>
              <option value="600_1800">10 to 30 minutes</option>
              <option value="1800_200000">More than 30 minutes</option>
            </select>
          </div>
          <div class="form-group m-r-10">
            <small class="text-muted">Level</small>
            <select [disabled]="filters.query ? true : false" [class.disabled]="filters.query" class="form-control custom-select-sm" (change)="filter()" [(ngModel)]="filters.level">
              <option value="any">Any</option>
              <option value="none">None Set</option>
              <option value="0">Easy</option>
              <option value="1">Intermediate</option>
              <option value="2">Difficult</option>
              <option value="3">Expert</option>
            </select>
          </div>
          <div class="form-group m-r-10">
            <small class="text-muted">Sort By</small>
            <select [disabled]="filters.query ? true : false" [class.disabled]="filters.query" class="form-control custom-select-sm" (change)="filter()" [(ngModel)]="filters.sort_by">
              <option value="date">Date</option>
              <option value="title">Title</option>
            </select>
          </div>
          <div class="form-group m-r-10">
            <small class="text-muted">Sort Direction</small>
            <select [disabled]="filters.query ? true : false" [class.disabled]="filters.query" class="form-control custom-select-sm" (change)="filter()" [(ngModel)]="filters.sort_order">
              <option value="desc">Descending</option>
              <option value="asc">Ascending</option>
            </select>
          </div>
          <div class="form-group m-r-10">
            <small class="text-muted">&nbsp;</small>
            <span class="btn btn-secondary d-block" (click)="resetFilters()">Reset Filters</span>
          </div>
        </div>
        <div class="product-filter m-b-20">
          <div class="filter-input no-max-width">
            <input type="text" (keyup)="filter()" (paste)="filter()" [(ngModel)]="filters.query" [placeholder]="'sphere.filter_list' | translate" />
            @if (filters.query) {
              <div class="clear" (click)="filters.query = ''; filter()"><fa-icon icon="times"></fa-icon></div>
            }
          </div>
        </div>
        <myp-inline-loader [loading]="loading" height="200px" spinnerName="sharePageLoader"></myp-inline-loader>
        <div class="grid-container pad-10 wider">
          @for (video of displayedVideos; track video; let i = $index) {
            <myp-video-grid-item (videoClickedEvent)="videoClicked($event, i)" [admin]="true" [showAddToLesson]="true" [hideActionButtons]="false" [video]="video"></myp-video-grid-item>
          }
        </div>
        @if (totalPages) {
          <div class="d-flex justify-content-center m-b-20 m-t-100">
            <div class="d-flex align-items-center">
              <div style="width: 30px">
                @if (page != 0) {
                  <fa-icon class="circle-icon-btn" icon="chevron-left" (click)="paginate('previous')"></fa-icon>
                }
              </div>
              <small class="d-block m-x-10">{{ page * limit }} - {{ page * limit + limit > totalVideos ? totalVideos : page * limit + limit }} of {{ totalVideos }}</small>
              <div style="width: 30px">
                @if (page != totalPages) {
                  <fa-icon class="circle-icon-btn" icon="chevron-right" (click)="paginate('next')"></fa-icon>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
}
@if (displayedEducationSection == "courses") {
  <div class="row">
    <div class="col m-x-10">
      <div class="d-flex m-b-30 justify-content-between align-items-center">
        <div>
          <fui-heading [text]="'Manage Courses'" [level]="5"></fui-heading>
          <small>Drag & Drop to Reorder</small>
        </div>
        <span class="btn btn-primary" tabindex="0" (click)="showAddEditLearnGroup('course')">Create New Course</span>
      </div>
      <div dragula="LESSONS" [(dragulaModel)]="courses">
        @for (course of courses; track course) {
          <myp-learn-list-item [large]="false" [item]="course" [admin]="true" (itemClickedEvent)="showAddEditLearnGroup('course', course)"></myp-learn-list-item>
        }
      </div>
    </div>
  </div>
}
@if (displayedEducationSection == "lessons") {
  <div class="row">
    <div class="col m-x-10">
      <div class="d-flex m-b-30 justify-content-between align-items-center">
        <div>
          <fui-heading [text]="'Manage Lessons'" [level]="5"></fui-heading>
          <small>Drag & Drop to Reorder</small>
        </div>
        <span class="btn btn-primary" tabindex="0" (click)="showAddEditLearnGroup('lesson')">Create New Lesson</span>
      </div>
      <div dragula="LESSONS" [(dragulaModel)]="lessons">
        @for (lesson of lessons; track lesson) {
          <myp-learn-list-item [large]="false" [item]="lesson" [admin]="true" (itemClickedEvent)="showAddEditLearnGroup('lesson', lesson)"></myp-learn-list-item>
        }
      </div>
    </div>
  </div>
}
@if (displayedEducationSection == "folders") {
  <div class="row">
    <div class="col m-x-10">
      <div class="d-flex m-b-30 justify-content-between align-items-center">
        <div>
          <fui-heading [text]="'Manage Folders'" [level]="5"></fui-heading>
          <small>Drag & Drop to Reorder</small>
        </div>
        <span class="btn btn-primary" tabindex="0" (click)="showAddEditLearnGroup('folder')">Create New Folder</span>
      </div>
      <div dragula="FOLDERS" [(dragulaModel)]="folders">
        @for (folder of folders; track folder) {
          <myp-learn-list-item [large]="false" [item]="folder" [admin]="true" (itemClickedEvent)="showAddEditLearnGroup('folder', folder)"></myp-learn-list-item>
        }
      </div>
    </div>
  </div>
}
